import { render, staticRenderFns } from "./forgot-password-modal.vue?vue&type=template&id=c8907560&"
import script from "./forgot-password-modal.vue?vue&type=script&lang=ts&"
export * from "./forgot-password-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports